import type { TFunction } from 'i18next';
import { object, string } from 'zod';

import { MAYOR_GREETING_MAX_LENGTH } from '@/features/profile-setting/constants/organization';

export const territorialAuthorityDataSchema = (
  t: TFunction<
    'profile-setting',
    'screens.organization-create' | 'screens.organization-edit'
  >
) =>
  object({
    mayorGreeting: string()
      .trim()
      .max(
        MAYOR_GREETING_MAX_LENGTH,
        t('errors.mayorGreetingTooLong', { max: MAYOR_GREETING_MAX_LENGTH })
      )
      .optional()
  });
